import React, { Component } from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react';
import { MessageBars } from '../Outils/MessageBars';

import { TimelineVerticale } from '../Timeline/TimelineVerticale';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataLotCommercial } from '../../data/DataLotCommercial.jsx';

/****************************************************************
 PROPS:
    idLotCommercial
    onAffichePanelLotCommercialHistorique
    onFermeFicheLotCommercialHistorique : méthode
****************************************************************/

var objetState = {
    idLotCommercial: 0,
    listHistorique: [],

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

export class FicheLotCommercialHistorique extends Component {
    _creationContent() {
        return (this.state.listHistorique !== null && this.state.listHistorique.length > 0 ? <TimelineVerticale listeActions={this.state.listHistorique} /> : <span>Aucune information n'est disponible sur les 3 derniers mois.</span>);
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheLotCommercialHistorique();
    }

    _onMiseAJourChamp = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    }

    _onMiseAJourChampNombre = (nomObjet, nomPropriete, valeur) => {
        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur)

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    }

    _chargementDonnees() {
        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Chargement de l'historique du lot commercial" });

        var chargementLotCommercial = DataLotCommercial._chargementHistoriqueLotCommercial(this.props.idLotCommercial);

        chargementLotCommercial
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = {};

                    stateTemp.idLotCommercial = this.props.idLotCommercial;
                    stateTemp.listHistorique = objetData;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };

    componentDidMount() {
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        let content = this._creationContent();

        return (
            <Panel
                isOpen={this.props.onAffichePanelLotCommercialHistorique}
                headerText="Historique sur les 3 derniers mois du lot commercial"
                type={PanelType.large}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            {content}
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }
}
